import { Component, Input, OnInit } from "@angular/core";
import { Equipment } from "src/app/app/equipment/equipment.model";
import { EquipmentService } from "src/app/app/equipment/equipment.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-assign-equipment",
  templateUrl: "./assign-equipment.component.html",
  styleUrls: ["./assign-equipment.component.scss"],
})
export class AssignEquipmentComponent implements OnInit {
  constructor(
    public equipmentServce: EquipmentService,
    public spaceService: SpaceService
  ) {}

  equipment: Equipment[] = [];

  @Input()
  equipmentList: any;

  @Input()
  spaceType: SpaceType;

  ngOnInit() {
    this.spaceService.equipmentList = this.equipmentList
      ? this.equipmentList
      : [];
    this.equipmentServce
      .getEquipments(this.spaceType)
      .subscribe((equipments: Equipment[]) => {
        this.equipment = equipments;
      });
  }

  /**
   * Dodaje i usuwa ekwipunek z tablicy ekwipunku przypisanego do sali
   *
   * @param {Equipment} equipment
   * @memberof AssignEquipmentComponent
   */
  changeEquipment(equipment: Equipment) {
    if (this.isInEquipmentList(equipment.id)) {
      this.spaceService.equipmentList = this.spaceService.equipmentList.filter(
        (elem) => {
          return elem.id != equipment.id;
        }
      );
    } else {
      this.spaceService.equipmentList.push(equipment);
    }
  }

  /**
   * Funkcja sprawdzająca, czy dane wyposażenie jest przypisane do salki.
   * Funkcja includes była wadliwa
   *
   * @param {number} eqId id wyposażenia
   * @return {*}  {Boolean}
   * @memberof AssignEquipmentComponent
   */
  isInEquipmentList(eqId: number): Boolean {
    let ret = false;
    this.spaceService.equipmentList.forEach((e) => {
      if (e.id === eqId) {
        ret = true;
        return;
      }
    });
    return ret;
  }
}
